import React from "react";
import TimeBlock from "../../../assets/TimeBlock";
import ShopPreview from "../../../assets/ShopPreview";

export default function SummarySection({ values, onChange }) {

	const {
		acceptCollection,
		collectionTimes,
		acceptDelivery,
		deliveryTimes,
	} = values;

	const orderTypes = [
		[acceptCollection, "collection"],
		[acceptDelivery, "delivery"]
	].filter(([b]) => b);

	return <div className="summarySection">
		<div className="details">
			Have a quick check of what you've chosen so far.
			<br /><br />
			Don't worry if you aren't sure about anything, you can make changes whenever you want in your shop details page.
		</div>
		<h3>Brand Stuff</h3>
		<div className="details" style={{ marginBottom: 20 }}>
			Here's an approximate preview of the top of your shop page.
		</div>
		<ShopPreview {...values} />
		<br /><br />
		<div className="details" style={{ marginBottom: 20 }}>
			You're offering {orderTypes.map(([, o]) => o).join(" and ")}{orderTypes.length === 1 && " only"}. Here are the opening hours you've picked:
		</div>
		{/* <h3>Order types</h3> */}
		<div className="flexy wrapping times-wrapper">
			{Boolean(acceptDelivery && deliveryTimes && deliveryTimes.length) && <div className="times">
				<h3 style={{ paddingTop: 0 }}>Delivery Times</h3>
				<TimeBlock times={deliveryTimes} />
			</div>}
			{Boolean(acceptCollection && collectionTimes && collectionTimes.length) && <div className="times">
				<h3 style={{ paddingTop: 0 }}>Collection Times</h3>
				<TimeBlock times={collectionTimes} />
			</div>}
		</div>
		<br /><br />
		<h2>Ready?</h2>
		<div className="details">
			If you're happy with the settings so far, hit continue and let us do the magic. If you want to make any changes, press the back button to review your choices, or just make the changes later in your account!
		</div>
	</div>
}